import a from "./Badge.vue2.mjs";
import { resolveComponent as d, openBlock as s, createElementBlock as t, normalizeClass as r, createCommentVNode as l, renderSlot as m, createVNode as u, createElementVNode as c } from "vue";
import f from "../../_virtual/_plugin-vue_export-helper.mjs";
const p = /* @__PURE__ */ c("circle", {
  cx: "4",
  cy: "4",
  r: "3"
}, null, -1), k = [
  p
];
function v(e, o, C, w, h, y) {
  const i = d("XMarkIcon");
  return s(), t("div", {
    class: r(["inline-flex select-none items-center whitespace-nowrap font-medium", e.classes])
  }, [
    e.dot ? (s(), t("svg", {
      key: 0,
      class: r(e.dotClasses),
      fill: "currentColor",
      viewBox: "0 0 8 8"
    }, k, 2)) : l("", !0),
    m(e.$slots, "default"),
    e.removable ? (s(), t("button", {
      key: 1,
      type: "button",
      class: r(["ml-0.5 inline-flex size-4 shrink-0 items-center justify-center rounded-full p-0.5 focus:outline-none focus:ring-1", e.removeButtonClasses]),
      onClick: o[0] || (o[0] = (...n) => e.handleRemoveClick && e.handleRemoveClick(...n)),
      onMousedown: o[1] || (o[1] = (...n) => e.handleRemoveMousedown && e.handleRemoveMousedown(...n))
    }, [
      u(i)
    ], 34)) : l("", !0)
  ], 2);
}
const R = /* @__PURE__ */ f(a, [["render", v]]);
export {
  R as default
};
//# sourceMappingURL=Badge.vue.mjs.map
